import { mapState, mapActions, mapGetters } from 'vuex';
import _ from 'lodash-extended';
import tmBus from '../../api/tmBus';
import fg from '#/libs/FrameGrid';
import { CursorManager } from '../../api/tapi';
import gridMixin from 'v/Story/Timeline/view/grid.mixin';

export default {
  mixins: [gridMixin],

  computed: {
    ...mapState('timemachine', {
      MODE_SCENE_EDIT: (state) => state.MODE.SCENE_EDIT,
      MODE_RCP_MSG_PLAY: (state) => state.MODE.RCP_MSG_PLAY,
      MODE_SECONDHAND_CUT: (state) => state.MODE.SECONDHAND_CUT,
    }),
    ...mapGetters('timemachine', ['maxLayerDuration']),

    moveObj() {
      return {
        enabled: !this.MODE_RCP_MSG_PLAY,
        distance2trigger: this.CONST.DND_SENSITIVITY.SECONDHAND,
        onMoveStart: this.$_onMoveStart,
        onMove: this.$_onMove,
        onMoveEnd: this.$_onMoveEnd,
      };
    },
  },

  methods: {
    ...mapActions('timemachine', [
      'SET_MODE',
      'SET_DND_ESCORT',
      'SET_SECONDHAND',
    ]),

    $_onMoveStart(state) {
      if (this.MODE_SECONDHAND_CUT) {
        this.SET_MODE({ name: 'SECONDHAND_CUT', value: false });
      }
      this.SET_MODE({ name: 'SECONDHAND_DND', value: true });
      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: true });

      state.eDownTimePoint = this.$_mouse2point(state.eDown);
      state.startTime = this.timePoint.time;
      state.shiftX = this.timePoint.x - state.eDownTimePoint.x;
      state.from = state.el.dataset.from;

      CursorManager.set('grabbing');
    },

    $_onMove(state) {
      const newPoint = this.$_mouse2point(state.eMove, null, state.shiftX);
      let time = newPoint.time;
      if (this.MODE_SCENE_EDIT) {
        // TODO: zendive.timelineRedesign.phase2 - constrain time while MODE_SCENE_EDIT
      } else {
        time = _.constrain(0, fg.trunc(time), this.maxLayerDuration);
      }
      this.SET_SECONDHAND({ time });
      tmBus.$emit('callbackRCPSeek', {
        time: this.secondhand,
        seekImmediate: false,
      });
    },

    $_onMoveEnd(state) {
      if (state.canceled) {
        this.SET_SECONDHAND({ time: state.startTime });
        tmBus.$emit('callbackRCPSeek', {
          time: state.startTime,
          seekImmediate: true,
        });
      } else {
        tmBus.$emit('callbackSecondhandDragStop', {
          draggingFrom: state.from,
        });
      }
      this.SET_DND_ESCORT({ name: 'useScrollSensor', value: false });
      this.SET_MODE({ name: 'SECONDHAND_DND', value: false });
      CursorManager.restore();
    },
  },
};
